import { render, staticRenderFns } from "./ListagemCotacaoProdutos.vue?vue&type=template&id=1c72f572"
import script from "./ListagemCotacaoProdutos.vue?vue&type=script&lang=js"
export * from "./ListagemCotacaoProdutos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports